import { createSelector, defaultStateFn } from '@ngrx/store';
import { AppState } from 'src/app/store/app.states';
import { IRollinState } from './state';

const state = (state: AppState) => state.rollinState;

export const rollin_Form = createSelector(
  state,
  (state: IRollinState) => state.form
);

export const rollin_TransferOptions = createSelector(
  state,
  (state: IRollinState) => state.transferOptions
);

export const rollin_SavedSuperFunds = createSelector(
  state,
  (state: IRollinState) => state.savedSuperFunds
);

export const rollin_CanSearch = createSelector(
  state,
  (state: IRollinState) => {
    var lastSuperFundModel = state.form.value.superFundList[state.form.value.superFundList.length - 1];

    return !lastSuperFundModel.usi;
  }
);

export const rollin_CanAddNewSuperfund = createSelector(
  state,
  (state: IRollinState) => {
    var canAdd = true;

    state.form.value.superFundList.forEach(fund => {
      if (!fund.memberNumber){
        canAdd = false;
      }
      if (fund.wholeAmount == 2 && !fund.amountToTransfer){
        canAdd = false;
      }
    })

    return canAdd;
  }
);

export const rollin_SuperFundList = createSelector(
  state,
  (state: IRollinState) => {
    return state.form?.value.superFundList;
  }
);